export default "__VITE_ASSET__C_$KlmR7__"